import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import CTAs from "./CTAs";

const statusColorMap = {
  Pending: { bg: "#FEF3C7", text: "#92400E", dot: "#F59E0B" },
  Approved: { bg: "#F0FDF4", text: "#166534", dot: "#22C55E" },
  InProgress: { bg: "#EFF6FF", text: "#1E40AF", dot: "#2563EB" },
};

const CaseCard = ({
  initialName,
  initialStatus,
  initialPrice,
  caseType,
  reference,
  dateCreated,
  dueDate,
  defenceStatus,
  lastAction,
  caseId,
  contactInfo,
  claimDetails,
}) => {
  const navigate = useNavigate();

  const onCTAsContainerClick = useCallback(() => {
    navigate("/defence2", {
      state: {
        caseData: {
          name: initialName,
          status: initialStatus,
          price: initialPrice,
          type: caseType,
          reference,
          dateCreated,
          dueDate,
          defenceStatus,
          lastAction,
          caseId,
          contactInfo,
          claimDetails,
        },
      },
    });
  }, [
    navigate,
    initialName,
    initialStatus,
    initialPrice,
    caseType,
    reference,
    dateCreated,
    dueDate,
    defenceStatus,
    lastAction,
    caseId,
    contactInfo,
    claimDetails,
  ]);

  const [name] = useState(initialName);
  const [status] = useState(initialStatus);
  const [price] = useState(initialPrice);

  const statusColors = statusColorMap[status] || statusColorMap.InProgress;

  return (
    <div
      className="dd-card"
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        transition: "box-shadow 0.2s ease, transform 0.2s ease",
      }}
    >
      {/* Card body */}
      <div style={{ padding: "20px 24px", flex: 1 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 12,
          }}
        >
          <span style={{ fontSize: 16, fontWeight: 700, color: "#0F172A" }}>
            {name}
          </span>
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              padding: "3px 10px",
              borderRadius: 20,
              fontSize: 11,
              fontWeight: 700,
              background: statusColors.bg,
              color: statusColors.text,
              border: `1px solid ${statusColors.dot}20`,
            }}
          >
            <span
              style={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                background: statusColors.dot,
                display: "inline-block",
              }}
            />
            {status}
          </span>
        </div>
        <div
          style={{
            fontFamily: "'DM Mono', monospace",
            fontSize: 28,
            fontWeight: 500,
            color: "#0F172A",
          }}
        >
          £
          {(price || 0).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </div>
      </div>

      {/* Footer */}
      <div
        style={{
          padding: "12px 24px",
          borderTop: "1px solid #F1F5F9",
          background: "#FAFBFD",
        }}
      >
        <CTAs
          type="Secondarybtn"
          text="View details"
          width="100%"
          onClick={onCTAsContainerClick}
        />
      </div>
    </div>
  );
};

export default CaseCard;
